
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gAmDLtzYAcaHJ9kkbgiXZwrFnMhLOdYmVFT2r2v9Q7doMeta } from "/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexuF6DUab_45v9OVS6iTqlCnI6TMWhDtSjG9CDp4EBXnzmMMeta } from "/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchFZ_45gEMDg4fCqyakxv0OkfghAMrNyuyj_45dy06AjTXkjgMeta } from "/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexp_4585yLrSXec3XT4_MJ7aPPxxvPwXw63KSSP7Xculwz8Meta } from "/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93pY9R4mnWUPrCC8_lkEQB6WlG4UcIugHg_n81ud6m2isMeta } from "/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexGCZ_45oq6YIVjASRzffR1ZWZQZIoskyxmr7s4Hk5qTEWYMeta } from "/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93gnIdgbM7QSqgKqfksnrGMOKqKy_Ju1Hj6SmqT3dk3hgMeta } from "/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexJ5Cw6dLc61y8W_IO1X8hYVToG3LFvTFu3IcmKklyNIAMeta } from "/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93VipQS847BcPoCC5Yq3il_4HtqAtqRqTi_45INREk2aWI8Meta } from "/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexWZ9TsOMiX4JoI19qTsEadv4BRzrtf7l7JMzyNjzWToIMeta } from "/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexPWU4gVNHUIZmNzwfeg4pstnqZRecGoTHyd2p80F4c04Meta } from "/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexGCZ_45oq6YIVjASRzffR1ZWZQZIoskyxmr7s4Hk5qTEWYMeta || {},
    component: () => import("/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexJ5Cw6dLc61y8W_IO1X8hYVToG3LFvTFu3IcmKklyNIAMeta || {},
    component: () => import("/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexWZ9TsOMiX4JoI19qTsEadv4BRzrtf7l7JMzyNjzWToIMeta || {},
    component: () => import("/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexPWU4gVNHUIZmNzwfeg4pstnqZRecGoTHyd2p80F4c04Meta || {},
    component: () => import("/codebuild/output/src726861320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]